import Map from 'pages/AddProfile/LocationModal/Map'
import { updatedBoard } from 'api/urls'
import React, { useState } from 'react'
import { POST } from 'api/request'
import Modal from './Modal'

interface AddGpsModalProps {
  boardId: string
  reload: base.BasicFunc
  onClose: base.BasicFunc
}

const AddGpsModal: React.FC<AddGpsModalProps> = ({ boardId, reload, onClose }) => {
  const [coords, setCoords] = useState<base.Coords | undefined>(undefined)
  const [isSending, setSending] = useState(false)

  const send = async () => {
    if (isSending || !coords) return
    setSending(true)
    try {
      const body = {
        gps: { latitude: coords.latitude, longitude: coords.longitude }
      }
      const response = await POST(updatedBoard(boardId), { body })
      if (response.ok) {
        reload()
        onClose()

      } else {
        throw new Error(':/')
      }
    } catch (error) {
      setSending(false)
    }
  }

  return (
    <Modal
      isLargeModal
      title='Dodaj lokalizacje'
      primaryDisabled={!coords}
      primaryButton={isSending ? 'ładowanie...' : 'Zapisz'}
      primaryButtonAction={send}
      secondaryButton='Anuluj'
      secondaryButtonAction='close'
      onClose={onClose}>
      <Map
        coords={coords}
        updatePosition={setCoords}
      />
    </Modal>
  )
}

export default AddGpsModal